import React from "react";
import { RouteComponentProps } from "@reach/router";
import { PolicyLayout } from "layouts";

export const TermsPage: React.FC<RouteComponentProps> = () => {
  return (
    <PolicyLayout>
      <h1 className="mb-2 mt-0">Terms of Use</h1>
      <div className="d-flex flex-column flex-1 overflow-auto px-2">
        <h2>JUSTLAW AGREEMENT TERMS OF USE</h2>
        <p> 
          These JustLaw Terms of Use, together with JustLaw’s Privacy Policy and, where 
          applicable, JustLaw’s Customer Subscription Agreement(collectively referred to as the 
          “Agreement”), constitute a legally binding agreement made between you, whether 
          personally or on behalf of an entity (“you”) and JustLaw (“JustLaw,” “we,” “us” or 
          “our”), concerning your access to and use of the https://justLaw.com website 
          (the “Site”) and the JustLaw application (the “Service”). You agree that by accessing 
          the Site and/or Service, you have read, understood, and agree to be bound by all of the 
          terms of the Agreement, including as they may be updated from time to time. If you do 
          not agree with all such terms, then you are expressly prohibited from using the Site 
          and Service and you must discontinue use immediately. Supplemental terms and 
          conditions that may be posted on the Site or within the Service from time to time are 
          hereby expressly incorporated herein by reference. We reserve the right, in our sole 
          discretion, to make changes or modifications to these JustLaw Terms of Use or to impose 
          additional terms and conditions at any time and for any reason. We will make 
          reasonable efforts to alert you about any material changes, including (but not 
          limited to) by posting a notice to our website, and you waive any right to receive 
          specific notice of each such change. It is your responsibility to periodically review 
          these JustLaw Terms of Use to stay informed of updates. You will be subject to, and 
          will be deemed to have been made aware of and to have accepted, the changes in any 
          revised JustLaw Terms of Use by your continued use of the Site or Service after the 
          date such revised JustLaw Terms of Use are posted. The information provided on the 
          Site and Service is not intended for distribution to or use by any person or entity in 
          any jurisdiction or country where such distribution or use would be contrary to law or 
          regulation or which would subject us to any registration requirement within such 
          jurisdiction or country. Accordingly, those persons who choose to access the Site or 
          Service from other locations do so on their own initiative and are solely responsible 
          for compliance with local laws, if and to the extent local laws are applicable. To use 
          the Site or Service, you agree that you (i) are at least eighteen (18) years of age; 
          (ii) have not previously been suspended or removed from the Site or Service; and (iii) 
          will register for and use the Site and Service in compliance with any and all 
          applicable laws and regulations as well as all applicable legal guidelines, rules or 
          frameworks (including state and local bar association rules).INTELLECTUAL PROPERTY 
          RIGHTS Unless otherwise indicated, the Site and Service are our proprietary property 
          and all source code, databases, functionality, software, website designs, audio, video, 
          text, photographs, graphics, and other contention the Site and Service (collectively, 
          the “Content”) and the trademarks, service marks, and logos contained therein (the 
          “Marks”) are owned or controlled by us or licensed to us, and are protected by 
          applicable copyright and trademark laws and various other intellectual property and 
          unfair competition laws of the United States, foreign jurisdictions, and international 
          conventions. The Content and the Marks are provided on the Site and Service “ASIS” for 
          your information and personal, non-commercial use only. Except as expressly provided 
          in these JustLaw Terms of Use, no part of the Site or Service and no Content or Marks 
          may be copied, reproduced, aggregated, republished, uploaded, posted, publicly 
          displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise 
          exploited for any commercial purpose whatsoever without our express prior written 
          permission. Provided that you are eligible to use the Site or Service, you are 
          granted a limited, revocable license to access and use the Site and Service and to 
          download or print a copy of any portion of the Content to which you have properly 
          gained access solely for your personal, non-commercial use. We reserve all rights 
          not expressly granted to you in and to the Site, the Service, the Content and the 
          Marks.
        </p>

        <h2>USER REGISTRATION</h2>
        <p>
          You may be required to register to take advantage of certain services. You agree 
          to keep your password confidential and will be responsible for all use of your 
          account and password. If you have reason to believe that your account is no longer 
          secure, you must immediately notify us at info@justlaw.com. We reserve the right 
          to remove, reclaim, or change a username you select if we determine, in our sole 
          discretion, that such username is inappropriate, obscene, or otherwise objectionable. 
          By registering or otherwise using the Site or Service, you represent and warrant that 
          all registration information you submit will be true, accurate, current, and complete 
          and that you will maintain the accuracy of such information and promptly update such 
          registration information as necessary.
        </p>
        <h2>FEES AND PAYMENT</h2>
        <p> 
          JustLaw may offer the JustLaw product and services for purchase through iTunes, 
          Google Play or other software application stores or markets. We may also offer the 
          JustLaw product and services for purchase by payment card. We accept the following 
          forms of payment:<br /><br />
            • Visa<br />
            • Mastercard<br />
            • American Express<br />
            • Discover<br />
            <br /><br />
          You agree to provide current, complete, and accurate purchase and account information 
          for all purchases made via the Site or Service. You further agree to promptly update 
          account and payment information, including email address, payment method, and payment 
          card expiration date, so that we can complete your transactions and contact you as 
          needed. We may use a third-party payment processor to bill you through an online 
          billing account for purchases made via the Site and Service. In such event, payment 
          processing will be subject to the terms of use and privacy policies of the payment 
          processor in addition to this Agreement. We are not responsible for any error by our 
          payment processor. Sales tax will be added to the price of purchases as deemed required 
          by us. We may change prices at any time. All payments shall be in U.S. dollars. 
          You agree to pay all charges or fees at the prices then in effect for your purchases, 
          and you authorize us to charge your chosen payment provider for any such amounts upon 
          making your purchase. We reserve the right to refuse any order placed through the Site 
          or Service.
        </p>

        <h2>APP STORE</h2>
        <p>
          You may download the JustLaw application from Apple’s app store, Google Play, or 
          other software application stores or markets. Each app store may have its own terms 
          and conditions to which you must agree before downloading an app from the store. If 
          you choose to download the JustLaw application from an app store or market, you 
          acknowledge that you have reviewed and accepted the terms of service applicable to 
          such store or market. If you download the JustLaw application from Apple’s app store, 
          you acknowledge and agree that:
          <br /><br />
            • The Agreement is concluded between you and JustLaw, and as between Apple and 
            JustLaw, JustLaw l (not Apple) is solely responsible for the JustLaw application and 
            its content. Your use of JustLaw must comply with the Apple App Store Terms of 
            Service, which are available here:https://www.apple.com/legal/internet-services/itunes/us/terms.html .
            <br /><br />
            • You will use the JustLaw application only on an Apple-branded product that you 
            own or control and as permitted by the “Usage Rules” set forth in the Apple App 
            Store Terms of Service.
            <br /><br />
            • JustLaw is responsible for any maintenance and support services with respect to 
            JustLaw. Apple has no obligation whatsoever to furnish any maintenance and support 
            services related to JustLaw.
            <br /><br />
            • In the event of any failure of the JustLaw application to conform to any applicable warranty, you may notify Apple and Apple will refund the purchase price of the application. To the maximum extent permitted by applicable law, Apple will have no other warranty obligation whatsoever with respect to the JustLaw application and as between Apple and JustLaw, any other claims, losses, liabilities, damages, costs, or expenses attributable to any failure to conform to any warranty will be JustLaw’s sole responsibility.
            <br /><br />
            • As between JustLaw and Apple, JustLaw (not Apple) is responsible for addressing 
            any claims asserted by you or any third party relating to the JustLaw application 
            or your possession and/or use of that application, including (but not limited to): 
            (i)product liability claims; 
            (ii) any claim that the JustLaw application fails to conform to any applicable 
            legal or regulatory requirement, and (iii) claims arising under consumer protection, 
            privacy, or similar legislation.
            <br /><br />
            • As between Apple and JustLaw, in the event of any third party claim that the 
            JustLaw application or your possession and use of that application infringes that 
            third party’s intellectual property rights, JustLaw l (not Apple) will be solely 
            responsible for the investigation, defense, settlement and discharge of any such 
            intellectual property infringement claim.
            <br /><br />
            • You are not located in a country that is subject to a U.S. Government embargo, 
            or that has been designated by the U.S. Government as a “terrorist supporting” 
            country; and(ii) you are not listed on any U.S. Government list of prohibited or 
            restricted parties. • Without limitation, you must comply with all applicable 
            third party terms of agreement when using the JustLaw application. Apple, and 
            Apple’s subsidiaries, are third party beneficiaries of the Agreement, and, upon 
            your acceptance of the Agreement, Apple will have the right (and will be deemed 
            to have accepted the right) to enforce the Agreement against you as a third party 
            beneficiary thereof. CANCELLATION You can cancel your subscription at any time by 
            logging into your account or contacting us using the contact information provided 
            below. If you cancel, you will continue to have access to JustLaw until the end of 
            your subscription term.
        </p>

        <h2>PROHIBITED ACTIVITIES You agree not to:</h2>
        <p>
          • Systematically retrieve data or other content from the Site or Service to create or 
          compile, directly or indirectly, a collection, compilation, database, or directory 
          without written permission from us.
          <br /><br />
          • Make any use of the Site or Service that is not authorized by the Agreement, 
          including by collecting usernames and/or email addresses of users by electronic or 
          other means for the purpose of sending unsolicited email, creating user accounts by 
          automated means or under false pretenses, or attempting to collect personal information 
          about users or third parties without their consent.
          <br /><br />
          • Use a buying agent or purchasing agent to make purchases on the Site or within the 
          Service.
          <br /><br />
          • Use the Site or Service to advertise or offer to sell goods and services, unless 
          specifically authorized by JustLaw.
          <br /><br />
          • Circumvent, disable, or otherwise interfere with security-related features of the 
          Site or Service or measures designed to prevent or restrict access to the Site or 
          Service (or any portion thereof), including features that prevent or restrict the 
          use or copying of any Content or enforce limitations on the use of the Site, Service 
          and/or the Content contained therein.
          <br /><br />
          • Engage in unauthorized framing of or linking to the Site or Service.
          <br /><br />
          • Trick, defraud, or mislead us and other users, especially in any attempt to learn 
          sensitive account information such as user passwords.
          <br /><br />
          • Make improper use of our support services or submit false reports of abuse or 
          misconduct.
          <br /><br />
          • Engage in any automated use of the system, such as using scripts to send comments 
          or messages, or using any data mining, robots, or similar data gathering and 
          extraction tools.
          <br /><br />
          • Interfere with, disrupt, or create an undue burden on the Site or Service or the 
          networks or services connected thereto.
          <br /><br />
          • Sell or otherwise transfer your profile or the access granted herein.
          <br /><br />
          • Use the Site or Service or any information obtained from the Site or Service in 
          order to harass, abuse, annoy, intimidate, threaten, disparage or harm another 
          person, JustLaw, or the Site or Service.
          <br /><br />
          • Use the Site or Service as part of any effort to compete with us or otherwise use 
          the Site or Service and/or the Content for any revenue-generating endeavor or 
          commercial enterprise.
          <br /><br />
          • Decipher, decompile, disassemble, copy, adapt, or reverse engineer any of the 
          software comprising or in any way making up a part of the Site or Service.
          <br /><br />
          • Violate or encourage others to violate the rights of third parties, including 
          intellectual property rights.
          <br /><br />
          • Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, 
          any material acting as a passive or active information collection or transmission 
          mechanism (including clear gifs, web bugs, cookies, spyware, and similar devices), 
          or other material, including any form of spamming, that interferes with any party’s 
          uninterrupted use and enjoyment of the Site or Service or modifies, impairs, 
          disrupts, alters, or interferes with the use, features, functions, operation, 
          or maintenance of the Site or Service.
          <br /><br />
          • Except as may be the result of standard search engine or Internet browser usage, 
          use, launch, develop, or distribute any automated system, including without 
          limitation, any spider, robot, cheat utility, scraper, or offline reader that 
          accesses the Site or Service, or using or launching any unauthorized script 
          or other software.
          <br /><br />
          • Use the Site or Service in a manner inconsistent with any applicable laws or 
          regulations(whether local, state, national, or international). USER GENERATED 
          CONTRIBUTIONS The Site and Service may invite you to chat, contribute to, 
          or participate in blogs, message boards, online forums, and other functionality 
          or forums, and may provide you with the opportunity to create, submit, post, 
          display, transmit, perform, publish, distribute, or broadcast content and 
          materials to us or on the Site or Service, including but not limited to text, 
          writings, video, audio, photographs, graphics, comments, suggestions, or personal 
          information or other material (collectively, “Contributions”).Contributions 
          may be viewable by other users of the Site or Service and through third-party 
          websites. As such, any Contributions you transmit may be treated as non-confidential 
          and non-proprietary. When you create or make available any Contributions, you 
          thereby represent and warrant that:
          <br /><br />
          • The creation, distribution, transmission, public display, or performance, and 
          the accessing, downloading, or copying of your Contributions do not and will not 
          infringe the rights of any third party, including but not limited to copyright, 
          patent, trademark, trade secret, privacy, publicity, or moral rights.
          <br /><br />
          • You are the creator and owner of or have the necessary licenses, rights, consents, 
          releases, and permissions to use and to authorize us, the Site, the Service, and 
          other users of the Site and Service to use your Contributions in any manner 
          contemplated by the Site and Service and the Agreement.
          <br /><br />
          • You have the written consent, release, and/or permission of each and every 
          identifiable individual person in your Contributions to use the name, likeness or 
          other information capable of identifying each and every such individual person 
          to enable inclusion and use of your Contributions in any manner contemplated by 
          the Site and the Agreement.
          <br /><br />
          • Your Contributions are not unsolicited or unauthorized advertising, promotional 
          materials, pyramid schemes, chain letters, spam, mass mailings, or other forms 
          of solicitation.
          <br /><br />
          • Your Contributions are not inaccurate, misleading, defamatory, libelous, or 
          slanderous, and would not be deemed by a reasonable person to be objectionable, 
          profane, indecent, pornographic, exploitative, harassing, discriminatory, threatening, 
          hateful, or otherwise inappropriate.
          <br /><br />
          • Your Contributions do not violate any applicable law or regulation (whether local, 
          state, national, or international), including (but not limited to) those concerning 
          child pornography or otherwise intended to protect the health or well-being of minors 
          and those relating to data privacy.
          <br /><br />
          • Your Contributions do not otherwise violate, or link to material that violates, 
          any provision of the Agreement, or any applicable law or regulation. We do not 
          assert any ownership over your Contributions and we are not liable for any 
          statements or representations in Contributions provided by you in any area on 
          the Site or within the Service. You are solely responsible for your Contributions 
          to the Site and Service and you expressly agree to exonerate us from any and all 
          responsibility or liability related to your Contributions and to refrain from 
          any legal action against us regarding your Contributions. We have the right, in 
          our sole and absolute discretion, to edit, remove, or otherwise change any 
          Contributions at any time and for any reason, without notice. We have no obligation 
          to monitor your Contributions. Public Contributions: By posting your Contributions 
          to any non-private part of the Site or Service, which includes all areas and portions 
          of the Site or Service aside from those to or in which access is limited to just 
          you and any attorney you have engaged or considering engaging 
          (“Public Contributions”), you automatically grant, and you represent and warrant 
          that you have the right to grant, to us an unrestricted, unlimited, irrevocable, 
          perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, 
          and license to host, use, copy, reproduce, disclose, sell, resell, publish, 
          broadcast, retitle, archive, store, cache, publicly perform, publicly display, 
          reformat, translate, transmit, excerpt (in whole or in part), and distribute such 
          Public Contributions (including, without limitation, your image and voice) for 
          any purpose, commercial, advertising, or otherwise, and to prepare derivative 
          works of, or incorporate into other works, such Public Contributions, and grant and 
          authorize sub licenses of the foregoing. The use and distribution may occur in any 
          media or form, now known or hereafter developed. You waive all moral rights in your 
          Public Contributions, and you warrant that moral rights have not otherwise been 
          asserted in your Public Contributions.
          <br /><br />
          Attorney-Client Communications:
          <br /><br />
          As described in our Privacy Policy, Attorney-Client Communications (information, 
          including Contributions, exchanged with any attorney that you choose to engage 
          (or whom you are considering engaging) through private chat functions) will not be 
          accessed, used or disclosed by JustLaw except as expressly set forth in the Privacy 
          Policy. You are responsible for evaluating whether these uses or disclosures have any 
          implications for any claim of privilege, including attorney-client and work product 
          privilege, regarding such information in your jurisdiction. You acknowledge and accept 
          that JustLaw is not a provider of legal services, advice, or counseling and no 
          attorney-client relationship exists between you and JustLaw. JustLaw is not 
          responsible for any opinions, advice, or other legal communications that may 
          be provided, shared, or otherwise communicated via the Site or Service or any 
          consequences thereof. Attorneys registered to use the Site or Service are not 
          employees or agents of JustLaw and JustLaw makes no representation concerning 
          the qualifications, competency, or skills of those attorneys. Should you choose 
          to engage an attorney, you do so at your own risk and any terms or agreements you 
          may enter with such attorney, including relating to fee arrangements, are between 
          you and your attorney and do not involve JustLaw in any way.
        </p>

        <h2>THIRD-PARTY WEBSITES AND CONTENT</h2>
        <p>
          The Site and Service may contain (or you may be sent via the Site or Service) links 
          to other websites (“Third-Party Websites”) as well as articles, photographs, text, 
          graphics, pictures, designs, music, sound, video, information, applications, software, 
          and other content or items belonging to or originating from third parties 
          (“Third-Party Content”). If you decide to leave the Site or Service and access the 
          Third-Party Websites or to use or install any Third-Party Content, you do so at your 
          own risk, and you should be aware this Agreement no longer govern. You should 
          review the applicable terms and policies, including privacy and data gathering 
          practices, of any website to which you navigate from the Site or Service or relating 
          to any applications you use or install from the Site or Service. You agree and 
          acknowledge that we have not reviewed, do not endorse and are not responsible for 
          any Third Party Websites (including the advertising, products, services or other 
          material offered thereon) or Third Party Content that may be included, linked to, 
          used or installed on the Site or through the Service. You agree and acknowledge 
          that JustLaw is not responsible for the legality, accuracy, or appropriateness of 
          such Third Party Websites or Third Party Content and shall not be responsible or 
          liable, directly or indirectly, for any harm, damage, or loss caused or alleged 
          to be caused by or in connection with the use of any such Third Party Websites 
          or Third Party Content.
          <br /><br />
          DIGITAL MILLENNIUM COPYRIGHT ACT (DMCA) NOTICE AND POLICY Notifications We respect 
          the intellectual property rights of others. If you believe that any material available 
          on or through the Site or Service infringes upon any intellectual property right 
          owned or controlled by you, please immediately notify our Designated Copyright Agent 
          in writing using the contact information provided below (a “Notification”). JustLaw 
          responds expeditiously to Notifications. If we remove content in response to your 
          Notification, a copy of your Notification will be sent to the person who posted or 
          stored the material addressed in the Notification. Please be advised that pursuant 
          to federal law you may be held liable for damages if you make material 
          misrepresentations in a Notification. Thus, if you are not sure that material 
          located on or linked to by the Site infringes your copyright, you should consider 
          first contacting an attorney.
          <br /><br />
          All Notifications should meet the requirements of 17 U.S.C.§ 512(c)(3) and include 
          (or substantially include) the following information:
          <br /><br />
          (1) A physical or electronic signature of a person authorized to act on behalf of 
          the owner of an exclusive right that is allegedly infringed;
          <br /><br />
          (2) identification of the copyrighted work claimed to have been infringed, or, if 
          multiple copyrighted works on the Site or within the Service are covered by the 
          Notification, a representative list of such works;
          <br /><br />
          (3) identification of the material that is claimed to be infringing or to be the 
          subject of infringing activity and that is to be removed or access to which is to be 
          disabled, and information reasonably sufficient to permit us to locate the material;
          <br /><br />
          (4)information reasonably sufficient to permit us to contact the complaining party, 
          such as an address, telephone number, and, if available, an email address at which 
          the complaining party may be contacted;
          <br /><br />
          (5) a statement that the complaining party has a good faith belief that use of the 
          material in the manner complained of is not authorized by the copyright owner, 
          its agent, or the law; and 
          <br /><br />
          (6) a statement that the information in the Notification is accurate, and under 
          penalty of perjury, that the complaining party is the owner or authorized to act on 
          behalf of the owner of an exclusive right that is allegedly infringed upon. 
          JustLaw has adopted and implements a policy that provides for termination in 
          appropriate circumstances of accounts of users who repeatedly infringe copyright or 
          other intellectual property rights of JustLaw or others.
          <br /><br />
          Counter Notification
          <br /><br />
          If you believe your own copyrighted material has been removed from the Site or Service 
          as a result of a mistake or misidentification, you may submit a written counter 
          notification to our Designated Copyright Agent using the contact information provided 
          below (a “Counter Notification”). To be an effective Counter Notification under the 
          DMCA, your Counter Notification must include substantially the following:
          <br /><br />
          (1) identification of the material that has been removed or disabled and the location 
          at which the material appeared before it was removed or disabled;
          <br /><br />
          (2) a statement that you consent to the jurisdiction of the Federal District Court 
          in which your address is located, or if your address is outside the United States, 
          for any judicial district in which we are located;
          <br /><br />
          (3) a statement that you will accept service of process from the party that filed 
          the Notification or the party’s agent;
          <br /><br />
          (4)your name, address, and telephone number; 
          <br /><br />
          (5) a statement under penalty of perjury that you have a good faith belief that the 
          material in question was removed or disabled as a result of a mistake or 
          misidentification of the material to be removed or disabled; and 
          <br /><br />
          (6) your physical or electronic signature. If you send us a valid, written Counter 
          Notification meeting the requirements described above, we will send a copy to the 
          party that filed the Notification notifying that party that we may replace or 
          restore or cease disabling access to the disputed content. Unless we receive 
          notice from the party filing the Notification within 14 days informing us that 
          such party has filed a court action to restrain you from engaging in infringing 
          activity related to the material in question, we will replace, restore or 
          otherwise cease disabling access to the disputed content or allow the user to re-post 
          the disputed content. Please note that if you materially misrepresent that the 
          disabled or removed content was removed by mistake or misidentification, you 
          may be liable for damages, including costs and attorney’s fees. Filing a false 
          Counter Notification constitutes perjury.
          <br /><br />
          Mr. Joe Richetti & Mr. Kevin Paganini<br />
          Bryan Cave Leighton Paisner LLP <br />
          1290 6th Avenue <br />
          New York City New York USA<br />
          212 541 2000
        </p>

        <h2>TERM AND TERMINATION</h2>
        <p>
          The Agreement shall remain in full force and effect while you use the Site or Service.
          <br /><br />
          WITHOUT LIMITING ANY OTHER PROVISION OF THESE THE AGREEMENT, WE RESERVE THE RIGHT TO, 
          IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF 
          THE SITE OR SERVICE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR 
          ANY REASON OR FOR NO REASON, WHETHER PERMANENTLY OR TEMPORARILY, INCLUDING WITHOUT 
          LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED OR 
          INCORPORATED IN THE AGREEMENT OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE 
          YOUR USE OR PARTICIPATION IN THE SITE OR SERVICE OR DELETE YOUR ACCOUNT AND ANY 
          CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR 
          SOLE DISCRETION.
          <br /><br />
          If we terminate or suspend your account for any reason, you are prohibited from 
          registering and creating a new account under your name, a fake or borrowed name, or 
          the name of any third party, even if you may be acting on behalf of the third party. 
          In addition to terminating or suspending your account, we reserve the right to take 
          appropriate legal action, including without limitation pursuing civil, criminal, and 
          injunctive redress. After your account is terminated, information and content 
          previously provided by you will no longer be accessible through your account, but 
          certain content may remain available and JustLaw may continue to use and store such 
          information and content and it may also be used and stored by third parties to whom 
          it has been transferred through your use of the Site or Service.
        </p>  

        <h2>MODIFICATIONS, INTERRUPTIONS, AND CORRECTIONS</h2>
        <p>
          We reserve the right to change, modify, or remove some or all of the Site or Service, 
          temporarily or permanently, at any time or for any reason at our sole discretion 
          without notice. We will not be liable to you or any third party for any modification, 
          price change, suspension, or discontinuance of the Site or Service. We cannot 
          guarantee the Site or Service will be available at all times or that all information 
          provided is accurate and without omissions. For example, we may experience hardware, 
          software, or other problems or need to perform maintenance related to the Site or 
          Service, resulting in interruptions, delays, or errors or information provided on 
          the Site or in the Service may have mistakes, factual inaccuracies or the like. We 
          reserve the right to change, revise, update, suspend, discontinue, or otherwise 
          modify the Site and Service at any time or for any reason without notice to you, 
          including to change, update, and correct any errors or inaccuracies related to the 
          information on the Site or within the Service. You agree that we have no liability 
          whatsoever for any loss, damage, or inconvenience caused by your inability to access 
          or use the Site or Service during any downtime or discontinuance of the Site. 
          Nothing in the Agreement will be construed to obligate us to maintain and support 
          the Site or Service or to supply any corrections, updates, or releases in connection 
          therewith.
        </p>


        <h2>GOVERNING LAW</h2>
        <p>
          The Agreement and your use of the Site and Service are governed by and construed 
          in accordance with the laws of the State of New York applicable to agreements 
          made and to be entirely performed within the State of New York, without regard 
          to its conflict of law principles.
        </p>

        <h2>DISPUTE RESOLUTION</h2>
        <p>
          Informal Negotiations
          <br /><br />
          To expedite resolution and control the cost of any dispute, controversy, or 
          claim related to the Agreement (each a “Dispute” and collectively, the “Disputes”) 
          brought by either you or us (individually, a“ Party” and collectively, the 
          “Parties”), the Parties agree to first attempt to negotiate any Dispute 
          (except those Disputes expressly provided below)informally for at least thirty 
          (30) days before initiating arbitration. Such informal negotiations commence 
          upon written notice from one Party to the other Party Binding Arbitration If 
          the Parties are unable to resolve a Dispute through informal negotiations, the 
          Dispute (except those Disputes expressly excluded below) will be finally and 
          exclusively resolved by binding arbitration on an individual basis. YOU UNDERSTAND 
          THAT WITHOUT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A 
          JURY TRIAL. The arbitration shall be commenced and conducted under the Commercial 
          Arbitration Rules of the American Arbitration Association (“AAA”) and, where 
          appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes 
          (“AAA Consumer Rules”), both of which are available at the AAA website www.adr.org. 
          Your arbitration fees and your share of arbitrator compensation shall be governed 
          by the AAA Consumer Rules and, where appropriate, limited by the AAA Consumer 
          Rules. If such costs are determined to by the arbitrator to be excessive, we will 
          pay all arbitration fees and expenses. The arbitration may be conducted in person, 
          through the submission of documents, by phone, or online. The arbitrator will make 
          a decision in writing,  but need not provide a statement of reasons unless requested 
          by either Party. The arbitrator must follow applicable law, and any award may be 
          challenged if the arbitrator fails to do so. Except where otherwise required by the 
          applicable AAA rules or applicable law, will take place in New York, NY. Except as 
          otherwise provided herein, the Parties may litigate in court to compel arbitration, 
          stay proceedings pending arbitration, or to confirm, modify, vacate, or enter 
          judgment on the award entered by the arbitrator. If for any reason, a Dispute 
          proceeds in court rather than arbitration, the Dispute shall be commenced or 
          prosecuted in the state and federal courts located in New York, NY, and the Parties 
          hereby consent to, and waive all defenses of lack of personal jurisdiction, 
          and forum non conveniens with respect to venue and jurisdiction in such state 
          and federal courts. Application of the United Nations Convention on Contracts 
          for the International Sale of Goods and The Uniform Computer Information 
          Transaction Act (UCITA) are excluded from the Agreement.
          <br /><br />
          Restrictions
          <br /><br />
          The Parties agree that any arbitration shall be limited to the Dispute between the 
          Parties individually. To the full extent permitted bylaw, 
          
          (a) no arbitration shall be joined with any other proceeding; 
          (b) there is no right or authority for any Dispute to be arbitrated on a 
          class-action basis or to utilize class action procedures; and 
          (c) there is no right or authority for any Dispute to be brought in a purported 
          representative capacity on behalf of the general public or any other persons. 
          Exceptions to Informal Negotiations and Arbitration.  The Parties agree that 
          the following Disputes are not subject to the above provisions concerning 
          informal negotiations and binding arbitration:

          (a) any Disputes seeking to enforce or protect, or concerning the validity of, any 
          of the intellectual property rights of a Party; 
          (b) any Dispute related to, or arising from, allegations of theft, 
          piracy, invasion of privacy, or unauthorized use; and 
          (c) any claim for injunctive relief. If this provision is found to be 
          illegal or unenforceable, then neither Party will elect to arbitrate any 
          Dispute falling within that portion of this provision found to be illegal or 
          unenforceable and such Dispute shall be decided by a court of competent 
          jurisdiction within the courts listed for jurisdiction above, and the Parties 
          agree to submit to the personal jurisdiction of that court.
        </p>

        <h2>DISCLAIMER</h2>
        <p>
            THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE 
            OF THE SITE AND OUR SERVICE WILL BE AT YOUR SOLE RISK. TOTHE FULLEST EXTENT 
            PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION 
            WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED 
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND 
            NON-INFRINGEMENT AS WELL AS ANY WARRANTIES ARISING OUT OF COURSE-OF-DEALING,USAGE, 
            OR TRADE. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR 
            COMPLETENESS OF THE SITE’S OR SERVICE’S CONTENT AND WE WILL ASSUME NO LIABILITY 
            OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND 
            MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
            RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE OR SERVICE, (3) ANY UNAUTHORIZED 
            ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION 
            AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF 
            TRANSMISSION TO OR FROM THE SITE OR SERVICE, (5) ANY BUGS,VIRUSES, TROJAN HORSES, 
            OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE OR SERVICE BY ANY 
            THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS 
            OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY 
            CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE OR 
            SERVICE.LIMITATIONS OF LIABILITY IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, 
            OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, 
            CONSEQUENTIAL,EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING 
            LOST PROFIT,LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE 
            OF THE SITEOR SERVICE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH 
            DAMAGES.NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY 
            TO YOUFOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL 
            AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO US DURING THE SIX 
            (6)MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION ARISING. CERTAIN STATE LAWS DO NOT 
            ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN 
            DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR 
            LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.
        </p>

        <h2>INDEMNIFICATION</h2>
        <p>
          You agree to defend, indemnify, and hold us harmless, including our subsidiaries, 
          affiliates, and all of our respective officers, agents, partners, and employees, 
          from and against any loss, damage, liability, claim, or demand, including 
          reasonable attorneys’ fees and expenses, due to, arising out of, or in any 
          way connected to:<br /><br />
‍
          (1) your Contributions;<br /><br />
‍
          (2) your access to or use of the Site or Service;<br /><br />
‍
          (3) your breach of the Agreement or violation of any applicable law, regulation, 
          legal guideline, rule or framework (including state and local bar association rules); 
          and<br /><br />
‍
          (4) your violation of the rights of a third party, including but not limited to 
          intellectual property or privacy rights. Notwithstanding the foregoing, we reserve 
          the right, at your expense, to assume the exclusive defense and control of any 
          matter for which you are required to indemnify us, and you agree to cooperate, 
          at your expense, with our defense of such claims. We will use reasonable efforts 
          to notify you of any such claim, action, or proceeding which is subject to this 
          indemnification upon becoming aware of it.
        </p> 

        <h2>ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</h2>
        <p>
          Visiting the Site, sending us emails, and completing online forms constitute 
          electronic communications. You consent to receive electronic communications, and 
          you agree that all agreements, notices, disclosures, and other communications we 
          provide to you electronically, via email and on the Site or within the Service, 
          satisfy any legal requirement that such communication be in writing. YOU HEREBY 
          AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, 
          AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS 
          INITIATED OR COMPLETED BY US OR VIA THE SITE OR SERVICE. You hereby waive any 
          rights or requirements under any statutes, regulations, rules, ordinances, or other 
          laws in any jurisdiction which require an original signature or delivery or 
          retention of non-electronic records, or to payments or the granting of credits 
          by any means other than electronic means.
        </p>

        <h2>CALIFORNIA USERS AND RESIDENTS</h2>
        <p>
          If any complaint with us is not satisfactorily resolved, you can contact the 
          Complaint Assistance Unit of the Division of Consumer Services of the California 
          Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, 
          Sacramento, California 95834 or by telephone at(800) 952-5210 or (916) 445-1254.
        </p>

        <h2>MISCELLANEOUS</h2>
        <p>
          This Agreement, constitutes the entire agreement and understanding between you and 
          us regarding your use of and access to the Site and Service. Our failure to exercise 
          or enforce any right or provision of the Agreement shall not operate as a waiver 
          of such right or provision. The Agreement operates to the fullest extent permissible 
          by law. We may assign any or all of our rights and obligations to others at any 
          time. If any provision or part of a provision of the Agreement is determined to be 
          unlawful, void, or unenforceable, that provision or part of the provision is 
          deemed severable from the Agreement and does not affect the validity and 
          enforceability of any remaining provisions. There is no joint venture, partnership, 
          employment or agency relationship created between you and us as a result of 
          this Agreement or your use of the Site or Service. You agree that the Agreement 
          will not be construed against us by virtue of having drafted it. You hereby waive 
          any and all defenses you may have based on the electronic form of the Agreement 
          and the lack of signing by the parties hereto to execute the Agreement.
        </p>

        <h2>CONTACT US</h2>
        <p>
          In order to resolve a complaint regarding the Site or Service or to receive further 
          information regarding use of the Site or Service, please contact us at:
          <br /><br />
          JusGlobal LLC d/b/a<br />
          JustLaw One World Trade Center<br />
          285 Fulton Street 85th Floor | Suite 8500<br />
          New York City NY 10007 USA<br />
          https://www.justlaw.com<br />
          attorney@justlaw.com<br />
        </p>
      </div>
    </PolicyLayout>
  );
};
